var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking-app"},[_c('a',{staticClass:"unregister button",on:{"click":function($event){$event.preventDefault();return _vm.unregister.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.translationHelper.getTranslation("camp_tracking_button_unsubscription")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }